

import { useState, useEffect } from 'react'
import { Slider } from './ui/shadcn/slider'
import { Switch } from './ui/shadcn/switch'
import Button from './ui/Button'
import { LuUndo2 } from 'react-icons/lu'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/shadcn/select'

export default function VoiceSettings({onChange, voiceSettings={}}) {
    const defaultSettings = {
        speed: 1,
        stability: 0.5,
        similarityBoost: 0.75,
        style: 0,
        useSpeakerBoost: false,
        model: 'eleven_multilingual_v2'
    }

    const [settings, setSettings] = useState({...defaultSettings, ...voiceSettings})

    useEffect(()=>{
        if(onChange) onChange(settings)
    },[settings])

    return (
        <div className='w-full h-full flex flex-col gap-4 pt-4 relative overflow-hidden'>
            <div className='px-4'>
                <h1 className='text-xl font-bold border-l-4 border-primary pl-4 capitalize'>Voice Settings</h1>
            </div>

            <div className='flex-1 flex flex-col gap-8 overflow-y-auto p-4'>
                <div className='flex flex-col gap-2'>
                    <label className='text-xs text-secondary-foreground'>Model</label>
                    <Select value={settings.model} onValueChange={(value) => setSettings({...settings, model: value})}>
                        <SelectTrigger>
                            <SelectValue placeholder='Select Model' />
                        </SelectTrigger>
                        <SelectContent className='bg-popover z-[100] '>
                            <SelectItem value='eleven_multilingual_v2' className='text-xs'>ElevenLabs Multilingual V2</SelectItem>
                            <SelectItem value='eleven_v3' className='text-xs'>ElevenLabs V3</SelectItem>
                        </SelectContent>
                    </Select>
                </div>
                <div className='flex flex-col gap-4'>
                    <label className='text-xs text-secondary-foreground'>Speed {settings.speed}</label>
                    <Slider value={[settings.speed]} max={1.2} min={0.7} step={0.01} onValueChange={(value) => setSettings({...settings, speed: value[0]})} />
                </div>
                <div className='flex flex-col gap-4'>
                    <label className='text-xs text-secondary-foreground'>Stability {(settings.stability*100).toFixed(0)}%</label>
                    <Slider value={[settings.stability]} max={1} min={0} step={0.01} onValueChange={(value) => setSettings({...settings, stability: value[0]})} />
                </div>
                <div className='flex flex-col gap-4'>
                    <label className='text-xs text-secondary-foreground'>Similarity {(settings.similarityBoost*100).toFixed(0)}%</label>
                    <Slider value={[settings.similarityBoost]} max={1} min={0} step={0.01} onValueChange={(value) => setSettings({...settings, similarityBoost: value[0]})} />
                </div>
                <div className='flex flex-col gap-4'>
                    <label className='text-xs text-secondary-foreground'>Style {(settings.style*100).toFixed(0)}%</label>
                    <Slider value={[settings.style]} max={1} min={0} step={0.01} onValueChange={(value) => setSettings({...settings, style: value[0]})} />
                </div>
                <div className='flex items-center'>
                    <Switch id='speaker-boost' checked={settings.useSpeakerBoost} onCheckedChange={(checked) => setSettings({...settings, useSpeakerBoost: checked})} />
                    <label htmlFor='speaker-boost' className='text-xs text-secondary-foreground pl-2 flex-1'>Speaker Boost</label>
                    <Button type='secondary' icon={<LuUndo2 className='w-4 h-4' />} className='p-1' onClick={() => setSettings(defaultSettings)}>Reset</Button>
                </div>
            </div>
        </div>
    )
} 